import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "mb-2 text-xl" }, "Describe Your Game", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "py-5 text-gray-text" }, "You can provide a description of your game's story.", -1)
const _hoisted_3 = { class: "form-group md:flex mb-3 items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "text-white text-sm w-36 my-2 md:my-0" }, "Description", -1)
const _hoisted_5 = { class: "py-7" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_editor = _resolveComponent("editor")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _hoisted_1,
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", null, [
          _createVNode(_component_editor, {
            modelValue: _ctx.details.About,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.details.About) = $event)),
            "api-key": "9jnfs249imm7zrkjewyq0e956gpatuk8q7ibj42i1ip52gmu",
            init: {
            height: 300,
            menubar: false,
            plugins: [
              'advlist autolink lists link image charmap print preview anchor',
              'searchreplace visualblocks code fullscreen',
              'insertdatetime media table paste code help wordcount',
            ],
            toolbar:
              'undo redo | formatselect | bold italic backcolor | \
                        alignleft aligncenter alignright alignjustify | \
                        bullist numlist outdent indent | removeformat | help',
          }
          }, null, 8, ["modelValue"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("button", {
        type: "button",
        class: _normalizeClass(["btn-primary px-5", [_ctx.details.About == '' ? 'opacity50' : '']]),
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.updateAbout && _ctx.updateAbout(...args)))
      }, "Save", 2)
    ])
  ], 64))
}